import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { onlineMcqRoutes } from './online-mcq.routing';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { sanitizeHtmlPipe } from './sanitize-html.pipe';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { QuestionsComponent } from './questions/questions.component';
import { OverallreportComponent } from './overallreport/overallreport.component';
import { QuizlistComponent } from './quizlist/quizlist.component';
import { DailyquizreportComponent } from './dailyquizreport/dailyquizreport.component';
import { InstructionComponent } from './instruction/instruction.component';
import { QuickreportComponent } from './quickreport/quickreport.component';
import { SolutionreportComponent } from './solutionreport/solutionreport.component';
import { CommonInstructionComponent } from './common-instruction/common-instruction.component';
import { DailyquizComponent } from './dailyquiz/dailyquiz.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule.forRoot(),
    NgbModule,
    NgxPermissionsModule.forChild(),
    RouterModule.forChild(onlineMcqRoutes),
    ChartsModule,
  ],
  declarations: [
    QuestionsComponent,
    sanitizeHtmlPipe,
    OverallreportComponent,
    QuizlistComponent,
    DailyquizreportComponent,
    InstructionComponent,
    QuickreportComponent,
    SolutionreportComponent,
    CommonInstructionComponent,
    DailyquizComponent,
  ],
  exports: [
    OverallreportComponent,
    SolutionreportComponent,
    DailyquizComponent
  ]
})
export class OnlineMcqModule {}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/online-mcq.module.ts